import { InjectionToken } from '@angular/core';
import { NavigationRouteConfig } from '@shared/models/interfaces/navigation-route-config';

export const NAVIGATION_ROUTE_CONFIG = new InjectionToken<NavigationRouteConfig>('navigation-route-config.token');
